import gql from 'graphql-tag';

export const openDoorAlertValueFragment = gql`
  fragment openDoorAlertValueParts on OpenDoorAlertValue {
    maxOccurrences
    firstDelayMinutes
    subsequentDelayMinutes
  }
`;

export const eventTriggerSettingFragment = gql`
  fragment eventTriggerSettingParts on EventTriggerSetting {
    id
    eventType
    name
    partnerPersonContextId
    condominiumPersonContextId
    placeId
    value {
      ...openDoorAlertValueParts
    }
  }
  ${openDoorAlertValueFragment}
`;
